module.exports = __webpack_public_path__ + "static/outlook_web_4-11bca675098e609574e08fe98c17125b.png";